module.exports = __webpack_public_path__ + "img/20.008d31cf.png";